import styled from 'styled-components'
import { t } from 'ttag'
import { useDispatch } from 'react-redux'

import { PB60T, PB90T } from '@h2/components/colors'
import {
  loadReportData,
  selectReport,
  setFilterParam
} from '@main/actions/admin/adminUserActions'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'
import { Button } from '@h2/components/buttons/button'

const StyledTable = styled.table`
  width: 100%;
`
const StyledHeaderRow = styled.tr`
  border-bottom: 1px solid ${PB60T};
`
const StyledHeaderCol = styled.th`
  font-weight: bold;
`
const StyledRow = styled.tr`
  &:nth-child(even) {
    background-color: ${PB90T};
  }
`
const StyledCol = styled.td`
  padding: 5px 3px;
`
const LessonTable = ({ data }) => {
  const dispatch = useDispatch()
  const navigator = useNavigator()
  const onSelectReport = event => {
    const selectedLesson = event.target?.dataset.lessonid

    event.preventDefault()
    const reportId = '10' //the lesson plan report id

    dispatch(setFilterParam('lessonId', selectedLesson))
    dispatch(selectReport(reportId, 'COMMON'))
    dispatch(loadReportData(reportId, 'COMMON'))
    navigator('/management/users')
  }

  return (
    <StyledTable>
      <thead>
        <StyledHeaderRow>
          <StyledHeaderCol>{t`Lesson Name`}</StyledHeaderCol>
          <StyledHeaderCol>{t`Last Assigned`}</StyledHeaderCol>
          <StyledHeaderCol>{t`Last Completed`}</StyledHeaderCol>
          <StyledHeaderCol>{t`Times Assigned`}</StyledHeaderCol>
          <StyledHeaderCol>{t`Actions`}</StyledHeaderCol>
        </StyledHeaderRow>
      </thead>
      <tbody>
        {data.lessons.map(row => (
          <StyledRow key={row.lessonId}>
            <StyledCol>{row.lessonName}</StyledCol>
            <StyledCol>
              {new Date(row.mostRecentAssignment).toLocaleDateString()}
            </StyledCol>
            <StyledCol>
              {new Date(row.mostRecentCompletion).toLocaleDateString()}
            </StyledCol>
            <StyledCol>{row.countOfAssignments}</StyledCol>
            <StyledCol>
              <Button
                variant="outlined"
                display="monochrome"
                size="small"
                data-lessonid={row.lessonId}
                onClick={onSelectReport}>
                {t`View Report`}
              </Button>
            </StyledCol>
          </StyledRow>
        ))}
      </tbody>
    </StyledTable>
  )
}

export { LessonTable }
